import { CompanyFileUploaded, TypeFileBusiness } from '@/types/FileType';
import yup from '@/helpers/validationsInputs';

export function buildFormDataFiles(objectFiles: TypeFileBusiness): FormData {
  const formData = new FormData();
  for (const [keyNameInput, files] of Object.entries(objectFiles)) {
    for (const file of files as File[]) {
      formData.append(keyNameInput, file);
    }
  }
  return formData;
}

export const acceptExtNames = [
  'pdf',
  'jpg',
  'jpeg',
  'png',
  'PDF',
  'JPG',
  'JPEG',
  'PNG',
];
/**
 * Extensiones aceptadas en el formato que espera `@flash-global66/g-attach-file`
 * (con punto y en minúsculas, el componente normaliza el case internamente).
 * Se deriva de `acceptExtNames` para mantener una única fuente de verdad:
 * si se agrega una extensión allí, esta lista se actualiza sola.
 * @example ['.pdf', '.jpg', '.jpeg', '.png']
 */
export const acceptExtNamesDS = [
  ...new Set(acceptExtNames.map((ext) => `.${ext.toLowerCase()}`)),
];

export const maxFilesSizeTen = 1024 * 1024 * 10; // 10MB

export const initData = {
  placeholder: 'Adjuntar archivo',
  inputRules: yup
    .array()
    .min(1, 'Debe seleccionar al menos 1 archivo')
    ['acceptExtNames'](acceptExtNames)
    .maxFilesSize(maxFilesSizeTen),
  acceptExtNames,
  maxFilesSize: maxFilesSizeTen,
  stateInput: 'selecting',
  valueProgress: 0,
  filesUploaded: [] as CompanyFileUploaded[],
};
